import React, { Component, PropTypes } from 'react'
import moment from 'moment-timezone'
import { linkTo } from 'event-taxonomy'
import css from './style.scss'

const PROGRAMS_LIMIT = 5

const zoneAbbr = ((zn) => {
  if (/E(S|D)T/.test(zn)) return 'ET'
  if (/P(S|D)T/.test(zn)) return 'PT'
  return zn
})(moment.tz(moment.tz.guess()).zoneAbbr())

const formatEventDateTime = (startAt) => {
  const m = moment(startAt)
  return `${m.format('MMM D, YYYY')} | ${m.format('h:mma')} (${zoneAbbr})`
}

class UpcomingWebinars extends Component {
  constructor (props) {
    super(props)
    this.state = { open: true }
    this.handleToggle = this.handleToggle.bind(this)
  }

  handleToggle () {
    this.setState(s => ({ open: !s.open }))
  }

  render () {
    const { events, textColor, linkColor } = this.props
    const { open } = this.state
    const headingStyle = textColor ? { color: textColor } : {}
    const linkStyle = linkColor ? { color: linkColor } : {}
    const webinars = (events || []).filter(e => e.type === 'webinar' && e.target)

    return (
      <div className={css.upcomingSection}>
        <div className={css.accordionHeader} onClick={this.handleToggle}>
          <h2 className={css.upcomingSectionTitle} style={headingStyle}>
            Upcoming Webinars
          </h2>
          <span className={css.accordionToggle} style={headingStyle}>{open ? '−' : '+'}</span>
        </div>
        {open && (
          <div className={css.accordionBody}>
            <p className={css.upcomingSectionSubtitle}>
              Register for upcoming webinars and events.
            </p>
            {webinars.length === 0
              ? (
                <p className={css.emptyState}>No upcoming webinars at this time.</p>
                )
              : (
                <ul className={css.eventList}>
                  {webinars.map((event) => (
                    <li key={event.id} className={css.eventListItem}>
                      <a href={linkTo(event)} className={css.eventLink} style={linkStyle} target='_blank' rel='noopener noreferrer'>
                        {event.target.title}
                      </a>
                      <span className={css.eventDate}>
                        {formatEventDateTime(event.target.start_at)}
                      </span>
                    </li>
                  ))}
                </ul>
                )}
            <a href='/events' className={css.viewAllLink} style={linkStyle} target='_blank' rel='noopener noreferrer'>
              View all upcoming events &rsaquo;
            </a>
          </div>
        )}
      </div>
    )
  }
}

UpcomingWebinars.propTypes = {
  events: PropTypes.arrayOf(PropTypes.object),
  textColor: PropTypes.string,
  linkColor: PropTypes.string
}

class UpcomingPrograms extends Component {
  constructor (props) {
    super(props)
    this.state = { open: true }
    this.handleToggle = this.handleToggle.bind(this)
  }

  handleToggle () {
    this.setState(s => ({ open: !s.open }))
  }

  render () {
    const { events, textColor, linkColor, subtitle } = this.props
    const { open } = this.state
    const headingStyle = textColor ? { color: textColor } : {}
    const linkStyle = linkColor ? { color: linkColor } : {}
    const regEndTime = event => {
      const date = event.target.open_registration_end_at
      return date ? moment(date).valueOf() : Number.MAX_SAFE_INTEGER
    }
    const programs = [...(events || [])]
      .filter(e => e.type === 'session_sale' && e.target)
      .sort((a, b) => regEndTime(a) - regEndTime(b))
      .slice(0, PROGRAMS_LIMIT)

    return (
      <div className={css.upcomingSection}>
        <div className={css.accordionHeader} onClick={this.handleToggle}>
          <h2 className={css.upcomingSectionTitle} style={headingStyle}>
            Upcoming Programs &amp; Courses
          </h2>
          <span className={css.accordionToggle} style={headingStyle}>{open ? '−' : '+'}</span>
        </div>
        {open && (
          <div className={css.accordionBody}>
            <p className={css.upcomingSectionSubtitle}>
              {subtitle || 'Multi-week programs and intensive courses for faculty at all career stages. Individual enrollment is available. Check with your institution about sponsorship or group enrollment opportunities.'}
            </p>
            {programs.length === 0
              ? (
                <p className={css.emptyState}>No upcoming programs at this time.</p>
                )
              : (
                <ul className={css.eventList}>
                  {programs.map((event) => (
                    <li key={event.id} className={css.eventListItem}>
                      <a href={`/sessions/${event.target.slug}`} className={css.eventLink} style={linkStyle} target='_blank' rel='noopener noreferrer'>
                        {event.target.title}
                      </a>
                      <span className={css.eventDate}>
                        {event.target.advertised_start_date
                          ? moment(event.target.advertised_start_date).format('MMM D, YYYY')
                          : formatEventDateTime(event.target.start_at)}
                      </span>
                    </li>
                  ))}
                </ul>
                )}
            <a href='/events' className={css.viewAllLink} style={linkStyle} target='_blank' rel='noopener noreferrer'>
              View all upcoming programs &amp; courses &rsaquo;
            </a>
          </div>
        )}
      </div>
    )
  }
}

UpcomingPrograms.propTypes = {
  events: PropTypes.arrayOf(PropTypes.object),
  textColor: PropTypes.string,
  linkColor: PropTypes.string,
  subtitle: PropTypes.string
}

export { UpcomingWebinars, UpcomingPrograms }
